<template>
	<!-- 목적 :  검색 셀렉트 박스 공통 콤보(단일, 연계 둘다 가능) -->
	<!-- 예시 : src\views\qms\FreeForm\Content\Search\SearchView.vue  -->
	<div class="sf-input-group-wrapper qms-select-combo">
		<template v-if="label">
			<span class="sf-input-group-wrapper__label">{{ label }}</span>
		</template>
		<div class="search-option-wrapper__normal">
			<el-select v-model="selectedData" :placeholder="label" @change="change" :disabled="disabled" v-bind="{ ...elObject }">
				<template v-if="showAll">
					<el-option :label="getMessage_('QWCC001282')" value=""></el-option>
				</template>
				<template v-if="options.length">
					<el-option
						v-for="(item, index) in options"
						:label="item.commCdName || item.label"
						:value="item.commCd || item.value"
						:key="index"
					></el-option>
				</template>
			</el-select>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
export default {
	name: 'select-combo',
	props: {
		label: { default: '' },
		paramKey: { default: '' },
		options: {
			default() {
				return [];
			}
		},
		showAll: { type: Boolean, default: true }, //'전체' 나오게 하기 여부
		propData: { default: '' },
		initData: { default: '' },
		disabled: { type: Boolean, default: false },
		elProps: {
			type: Object,
			default: () => {},
			description: 'el-element에서 제공하는 props들 매핑할 수 있는 Props'
		}
	},
	data() {
		return {
			selectedData: ''
		};
	},
	created() {
		this.selectedData = this.propData;
	},
	watch: {
		initData() {
			this.selectedData = ''; //연계 콤보시 첫번째 콤보가 변하면, 두 번째 콤보 값 초기화 설정을 위한 작업
		},
		propData() {
			this.selectedData = this.propData;
		}
	},
	methods: {
		...rootMethods,
		change(value) {
			this.$emit('commChange', { key: this.paramKey, value });
		},
		clear(){
			this.selectedData = '';
			this.change('');
		}
	},
	computed: {
		...rootComputed,
		elObject() {
			return this.elProps;
		}
	}
};
</script>
<style lang="scss">
.el-select .el-input .el-input__inner:disabled,
.el-select .el-input .el-input__inner:hover:disabled {
	color: var(--color-font-default) !important;
	background-color: #e0e0e0 !important;
}
</style>
